import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import HVACHero from './components/HVACHero';
import HVACServices from './components/HVACServices';
import HVACSystemsElPaso from './components/HVACSystemsElPaso';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import HVACFAQ from './components/HVACFAQ';

export default function HVACPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <main>
        <HVACHero />
        <HVACServices />
        <HVACSystemsElPaso />
        <ContractorDirectory />
        <ComparisonChecklist />
        <HVACFAQ />
      </main>
      <Footer />
    </div>
  );
}
